/* eslint-disable complexity,no-param-reassign */
// Overlay
// Show
// const showOverlay = (workspace) => {
//   if (document.querySelector('.overlay')) {
//     return;
//   }
//
//   document.body.classList.add('overlay-show');
//
//   const overlay = document.createElement('div');
//   if (workspace) {
//     overlay.setAttribute('class', 'overlay workspace');
//   } else {
//     overlay.setAttribute('class', 'overlay');
//   }
//
//   document.body.appendChild(overlay);
//   overlay.classList.add('active');
// };
// Hide
const hideOverlay = () => {
  const overlayToRemove = document.querySelector('.overlay');

  if (!overlayToRemove) {
    return;
  }

  document.body.classList.remove('overlay-show');

  overlayToRemove.classList.remove('active');
  document.body.removeChild(overlayToRemove);
};

// Event delegation
const on = (selector, eventType, childSelector, eventHandler) => {
  const elements = document.querySelectorAll(selector);

  if (elements) {
    elements.forEach((element: Element) => {
      element.addEventListener(
        eventType,
        (eventOnElement) => {
          if (eventOnElement.target.closest(childSelector)) {
            eventHandler(eventOnElement);
          }
        },
      );
    });
  }
};

// Viewport Width
// Define our viewportWidth variable
let viewportWidth;

// Set/update the viewportWidth value
const setViewportWidth = () => {
  viewportWidth = window.innerWidth || document.documentElement.clientWidth;
};

// Watch the viewport width
const watchWidth = () => {
  const menuHiddenClass = 'menu-hidden';

  const sm = 640;

  // const md = 768;
  const lg = 1024;

  // const xl = 1280;
  const menuBar = document.querySelector('.menu-bar');

  // Hide Menu Detail
  const hideMenuDetail = () => {
    if (menuBar !== null) {
      menuBar.querySelectorAll('.menu-detail.open').forEach((menuDetail) => {
        hideOverlay();

        if (!menuBar.classList.contains('menu-wide')) {
          menuDetail.classList.remove('open');
        }
      });
    }
  };

  // Hide Sidebar
  const hideSidebar = () => {
    const sidebar = document.querySelector('.sidebar');

    if (!sidebar) {
      return;
    }

    if (sidebar.classList.contains('open')) {
      sidebar.classList.remove('open');
      hideOverlay();
    }
  };

  if (viewportWidth < sm) {
    if (!menuBar) {
      return;
    }

    const openMenu = menuBar.querySelector('.menu-detail.open');

    if (!openMenu) {
      menuBar.classList.add(menuHiddenClass);
      document.documentElement.classList.add(menuHiddenClass);
      hideMenuDetail();
    }
  }

  if (viewportWidth > sm) {
    if (!menuBar) {
      return;
    }

    menuBar.classList.remove(menuHiddenClass);
    document.documentElement.classList.remove(menuHiddenClass);
  }

  if (viewportWidth > lg) {
    hideSidebar();
  }
};

// Set our initial width
setViewportWidth();
watchWidth();

// On resize events, recalculate
window.addEventListener(
  'resize',
  () => {
    setViewportWidth();
    watchWidth();
  },
  false,
);

// Open Collapse
const openCollapse = (collapse, callback?: () => unknown) => {
  collapse.style.transitionProperty = 'height, opacity';
  collapse.style.transitionDuration = '200ms';
  collapse.style.transitionTimingFunction = 'ease-in-out';

  setTimeout(
    () => {
      collapse.style.height = `${collapse.scrollHeight}px`;
      collapse.style.opacity = 1;
    },
    200,
  );

  collapse.addEventListener(
    'transitionend',
    () => {
      collapse.classList.add('open');

      collapse.style.removeProperty('height');
      collapse.style.removeProperty('opacity');

      collapse.style.removeProperty('transition-property');
      collapse.style.removeProperty('transition-duration');
      collapse.style.removeProperty('transition-timing-function');

      if (typeof callback === 'function') {
        callback();
      }
    },
    {
      once: true,
    },
  );
};

// Close Collapse
const closeCollapse = (collapse, callback?: () => unknown) => {
  collapse.style.overflowY = 'hidden';
  collapse.style.height = `${collapse.scrollHeight}px`;

  collapse.style.transitionProperty = 'height, opacity';
  collapse.style.transitionDuration = '200ms';
  collapse.style.transitionTimingFunction = 'ease-in-out';

  setTimeout(
    () => {
      collapse.style.height = 0;
      collapse.style.opacity = 0;
    },
    200,
  );

  collapse.addEventListener(
    'transitionend',
    () => {
      collapse.classList.remove('open');

      collapse.style.removeProperty('overflow-y');
      collapse.style.removeProperty('height');
      collapse.style.removeProperty('opacity');

      collapse.style.removeProperty('transition-property');
      collapse.style.removeProperty('transition-duration');
      collapse.style.removeProperty('transition-timing-function');

      if (typeof callback === 'function') {
        callback();
      }
    },
    {
      once: true,
    },
  );
};

// Collapse
const collapse = () => {
  const selector = '[data-toggle="collapse"]';

  // Toggle Collapse
  const toggleCollapse = (collapseTrigger) => {
    collapseTrigger.classList.toggle('active');

    // Collapse
    const collapses = document.querySelectorAll(collapseTrigger.dataset.target);

    collapses.forEach((collapseItem) => {
      if (collapseItem.classList.contains('open')) {
        closeCollapse(collapseItem);
      } else {
        openCollapse(collapseItem);
      }
    });

    // Accordion
    const accordion = collapseTrigger.closest('.accordion');

    if (accordion) {
      const accordionTriggers = accordion.querySelectorAll(selector);

      accordionTriggers.forEach((accordionTrigger) => {
        if (accordionTrigger !== collapseTrigger) {
          accordionTrigger.classList.remove('active');
        }
      });

      const accordions = accordion.querySelectorAll('.collapse');

      accordions.forEach((accordionItem) => {
        if (accordionItem.classList.contains('open')) {
          closeCollapse(accordionItem);
        }
      });
    }
  };

  on(
    'body',
    'click',
    selector,
    (event) => {
      const collapseTrigger = event.target.closest(selector);

      toggleCollapse(collapseTrigger);
    },
  );
};

collapse();
